<script setup>
import {
    formataCnpj,
    formataMoedaReais,
} from '@kodatec/brasil-utils';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})

</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados titulo="Pessoa Jurídica" :conteudo="props.solicitacao.dados.pessoa_juridica_razao_social"
        :detalhe="props.solicitacao.dados.pessoa_juridica_cnpj ? `CNPJ: ${formataCnpj(props.solicitacao.dados.pessoa_juridica_cnpj)}` : ''" />

    <LabelDados titulo="Valor"
        :conteudo="props.solicitacao.dados.valor ? formataMoedaReais(props.solicitacao.dados.valor) : 'Não informado'" />

    <LabelDados titulo="Justificativa" v-if="props.solicitacao.dados.justificativa"
        :conteudo="props.solicitacao.dados.justificativa" tamanho_div="col-12" />

    <div v-if="props.solicitacao.dados.detalhes_rubricas?.length" class="w-full">
        <hr class="w-full border-solid border-top-1 border-bottom-none surface-border mb-3 mt-3" />
        <h3 class="text-900 font-bold text-sm pb-0 mb-1 col-12">Valores por Rubrica</h3>
        <p class="text-500 pt-0 font-medium text-xs mt-0 mb-3 col-12">Detalhamento dos valores da receita por
            encerramento, discriminados por rubrica e item orçamentário.</p>

        <TabelaScrollContainer>
            <DataTable :value="props.solicitacao.dados.detalhes_rubricas" size="small" striped-rows>
                <Column field="rubrica_nome" header="Rubrica">
                    <template #body="{ data }">
                        <ColunaListas :titulo="data.rubrica_nome" :descricao="data.detalhe_rubrica_nome" />
                    </template>
                </Column>
                <Column field="valor" header="Valor" style="width: 160px; text-align: end;">
                    <template #body="{ data }">
                        <ColunaListas :titulo="formataMoedaReais(data.valor)" />
                    </template>
                </Column>
            </DataTable>
        </TabelaScrollContainer>
    </div>

</template>
